import { render } from "./RoleActionMappingsView.vue?vue&type=template&id=14981281&scoped=true&lang=pug"
import script from "./RoleActionMappingsView.vue?vue&type=script&lang=js"
export * from "./RoleActionMappingsView.vue?vue&type=script&lang=js"

import "./RoleActionMappingsView.vue?vue&type=style&index=0&id=14981281&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14981281"]])

export default __exports__